import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { catchError } from 'rxjs/operators';
import { Ocr } from '../models/ocr.model';

@Injectable()
export class OcrService {

  constructor(private httpClient: HttpClient, private baseService: BaseService) { }

  processOcr(formData: FormData): Observable<Ocr> {
    const url = `${this.baseService.hostDomain}/api/ocr`;
    return this.httpClient.post<Ocr>(url, formData).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Buscando las órdenes');
        return [];
      })
    );
  }
}
